import { Link } from 'react-router-dom'
import { Movimiento } from '../../types/inventario'
import { formatoFecha } from '../../utils/fecha'
import { describirMovimiento } from '../../utils/inventario'

/**
 * El historial de un bien o de una oficina, lo más reciente arriba. En una oficina
 * (`enRecinto`) cada fila nombra el bien y lleva a su ficha, y un traslado se lee como
 * entrada o salida.
 */
export function Historial({ movimientos, enRecinto }: { movimientos: Movimiento[]; enRecinto: boolean }) {
  if (!movimientos.length) return <p className="texto-secundario">Sin movimientos todavía.</p>
  return (
    <ol className="historial">
      {movimientos.map((m) => {
        const { titulo, detalle } = describirMovimiento(m, enRecinto)
        return (
          <li key={m.id} className="historial__item">
            <time className="historial__fecha" dateTime={m.fecha}>{formatoFecha(m.fecha)}</time>
            <div className="historial__cuerpo">
              <p className="historial__titulo">{enRecinto && m.bien ? <Link to={`/app/bienes/${m.bien.id}`}>{titulo}</Link> : titulo}</p>
              {detalle.map((linea) => (
                <p key={linea} className="historial__detalle">{linea}</p>
              ))}
              {m.motivo && <p className="historial__detalle">«{m.motivo}»</p>}
            </div>
            <span className="historial__usuario">{m.usuario ?? 'Carga inicial'}</span>
          </li>
        )
      })}
    </ol>
  )
}
